import React from "react"
import PropTypes from "prop-types"

const initials = (obj) => obj.firstName[0].toUpperCase() + obj.lastName[0].toUpperCase()

const UserIcon = (props) => {
  const session = props.session
  const icon = session.imageUrl ?
    <img src={session.imageUrl}/> : <span className="header-sub-user__initials">{initials(session)}</span>
  return <div className="header-sub-user__icon">{icon}</div>
}

const UserButton = props => {
  const sessions = props.sessions
  const isSession = sessions.length > 0
  return (
    <button onClick={props.onClick}>
      <div className="header-sub-user">
        {sessions.map((session, i) => <UserIcon key={session.id} session={session}/>)}
      </div>
      {!isSession && <img src="/images/sub-user-icon-2.png"/>}
      <div className="header-clock-in-button">{isSession ? "Clock in / out" : "Clock in"}</div>
    </button>
  )
}

export default UserButton
